import { createAsyncThunk } from "@reduxjs/toolkit";
import { IFinance } from "../../../helpers/types";
import FinanceService from "../../../api/FinanceService";

export const asyncGetFinancesAction = createAsyncThunk(
    "finance/all",
    async (query: any, thunkAPI) => {
        try {
            const response = await FinanceService.findAll(query);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncGetFinanceAction = createAsyncThunk(
    "finance/one",
    async (id: number, thunkAPI) => {
        try {
            const response = await FinanceService.findOne(id);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncCreateFinanceAction = createAsyncThunk(
    "finance/create",
    async (data: any, thunkAPI) => {
        try {
            const response = await FinanceService.create(data);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncUpdateFinanceAction = createAsyncThunk(
    "finance/update",
    async (payload: { id: number; data: any }, thunkAPI) => {
        try {
            const { id, data } = payload;
            const response = await FinanceService.update(id, data);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncDeleteFinanceAction = createAsyncThunk(
    "finance/delete",
    async (id: number, thunkAPI) => {
        try {
            const response = await FinanceService.delete(id);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncGetFinanceStatsAction = createAsyncThunk(
    "finance/stats",
    async (query: any, thunkAPI) => {
        try {
            const response = await FinanceService.getStats(query);
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);

export const asyncGetDailyDealsCountAction = createAsyncThunk(
    "finance/stats/daily-count",
    async (args: { period?: 'month' | 'year'; year?: number; month?: number } | undefined, thunkAPI) => {
        try {
            const response = await FinanceService.getDailyDealsCount(
                args?.period || 'month',
                args?.year,
                args?.month
            );
            return response.data;
        } catch (e: any) {
            return thunkAPI.rejectWithValue(e.response?.data?.message);
        }
    }
);